/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Document_Request_Message_PlaceholderInputs */

const en_document_request_message_placeholder = /** @type {(inputs: Document_Request_Message_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a message to your request (optional)…`)
};

const id_document_request_message_placeholder = /** @type {(inputs: Document_Request_Message_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tambahkan pesan untuk permintaan Anda (opsional)…`)
};

/** @type {(inputs: Document_Request_Message_PlaceholderInputs) => LocalizedString} */
const es_document_request_message_placeholder = en_document_request_message_placeholder;

/** @type {(inputs: Document_Request_Message_PlaceholderInputs) => LocalizedString} */
const fr_document_request_message_placeholder = en_document_request_message_placeholder;

/** @type {(inputs: Document_Request_Message_PlaceholderInputs) => LocalizedString} */
const de_document_request_message_placeholder = en_document_request_message_placeholder;

/** @type {(inputs: Document_Request_Message_PlaceholderInputs) => LocalizedString} */
const ja_document_request_message_placeholder = en_document_request_message_placeholder;

/** @type {(inputs: Document_Request_Message_PlaceholderInputs) => LocalizedString} */
const zh_document_request_message_placeholder = en_document_request_message_placeholder;

/** @type {(inputs: Document_Request_Message_PlaceholderInputs) => LocalizedString} */
const ar_document_request_message_placeholder = en_document_request_message_placeholder;

/** @type {(inputs: Document_Request_Message_PlaceholderInputs) => LocalizedString} */
const it_document_request_message_placeholder = en_document_request_message_placeholder;

/** @type {(inputs: Document_Request_Message_PlaceholderInputs) => LocalizedString} */
const ru_document_request_message_placeholder = en_document_request_message_placeholder;

/** @type {(inputs: Document_Request_Message_PlaceholderInputs) => LocalizedString} */
const pt_document_request_message_placeholder = en_document_request_message_placeholder;

/** @type {(inputs: Document_Request_Message_PlaceholderInputs) => LocalizedString} */
const ko_document_request_message_placeholder = en_document_request_message_placeholder;

/**
* | output |
* | --- |
* | "Add a message to your request (optional)…" |
*
* @param {Document_Request_Message_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const document_request_message_placeholder = /** @type {((inputs?: Document_Request_Message_PlaceholderInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Document_Request_Message_PlaceholderInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_document_request_message_placeholder(inputs)
	if (locale === "es") return es_document_request_message_placeholder(inputs)
	if (locale === "fr") return fr_document_request_message_placeholder(inputs)
	if (locale === "de") return de_document_request_message_placeholder(inputs)
	if (locale === "ja") return ja_document_request_message_placeholder(inputs)
	if (locale === "zh") return zh_document_request_message_placeholder(inputs)
	if (locale === "ar") return ar_document_request_message_placeholder(inputs)
	if (locale === "id") return id_document_request_message_placeholder(inputs)
	if (locale === "it") return it_document_request_message_placeholder(inputs)
	if (locale === "ru") return ru_document_request_message_placeholder(inputs)
	if (locale === "pt") return pt_document_request_message_placeholder(inputs)
	return ko_document_request_message_placeholder(inputs)
});